import { useCookies } from 'react-cookie';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const [{ token }] = useCookies(['token']);
  const location = useLocation();

  if (token == null) {
    return <Navigate to="/Login" state={{ from: location }} replace />;
  }

  return children ?? <Outlet />;
};

export default PrivateRoute;
